import { render, staticRenderFns } from "./ProjectHub.vue?vue&type=template&id=7227f6c2&scoped=true&"
import script from "./ProjectHub.vue?vue&type=script&lang=js&"
export * from "./ProjectHub.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHub.vue?vue&type=style&index=0&id=7227f6c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227f6c2",
  null
  
)

export default component.exports